import { makeStyles } from '@material-ui/core/styles';
import { ImportantDevices } from '@material-ui/icons';

const useStyles = makeStyles({
    padding: {
        padding: '10px',
    },
    buyerSection: {
        paddingTop: '20px',
        paddingLeft: '20px',
        paddingBottom: '20px',
    },
    borderTop: {
        borderTop: '1px solid',
    },
    borderLeft: {
        borderLeft: '1px solid',
    },
    borderRight: {
        borderRight: '1px solid',
    },
    borderBottom: {
        borderBottom: '1px solid',
    },
    border: {
        border: '1px solid',
    },
    fontNormal: {
        fontWeight: 'normal',
    },
    btn: {
        height: '30px',
        marginTop: '20px',
        marginBottom: '20px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    editBtn: {
        background: '#F8961D',
        '&:hover': {
            background: '#F8961D',
        },
    },
    blackBtn: {
        background: '#000000',
        marginLeft: '20px !important',
        // width: '206px',
        '&:hover': {
            background: '#000000',
        },
    },
    roundedOff: {
        fontSize: 'inherit',
        fontWeight: '400',
    },
    logoBlock: {
        paddingTop: '30px',
        paddingLeft: '20px',
        borderTop: '1px solid',
        borderLeft: '1px solid',
    },
    displayFlex: {
        display: 'flex',
    },
    paddingBottom: {
        paddingBottom: '20px',
    },
    errorDiv: {
        width: '100%',
        textAlign: 'center',
        color: 'FF0000',
    },
    inlineUl: {
        width: '100%',
        listStyle: 'none',
    },
    leftFloat: {
        float: 'left',
        width: '50%',
    },
    inline: {
        display: 'inline',
    },
    listRoot: {
        width: '100%',
        // maxWidth: '36ch',
        // backgroundColor: theme.palette.background.paper,
    },
    paddingTB0: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    bgLightGrey: {
        background: '#f0f0f4',
        padding: '20px 0px',
    },
    marginR25: {
        marginRight: '25px !important',
    },
    paddingCard: {
        padding: '20px 12px',
    },

    bgNone: {
        backgroundColor: 'transparent',
        border: '1px solid #e6e6e6',
        fontFamily: 'Rubik !important',
        fontSize: '14px',
    },
    padding0: {
        padding: '0 !important',
    },
    intermediarybutn: {
        background: '#4c4fa6',
        color: '#fff',
        padding: '12px 40px',
        borderRadius: '6px',
        fontFamily: 'Rubik',
        fontWeight: '500 !important',
        fontSize: '15px !important',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: '#4c4fa6',
        },
    },
    fontRubik: {
        fontFamily: 'Rubik',
        fontSize: '14px',
    },
    fontRubikBold: {
        fontWeight: '600',
    },
    paddingCard2035: {
        padding: '20px 35px',
        ['@media (max-width:600px)']: {
            padding: '20px 10px',
        },
    },
    clientCard: {
        boxShadow: '0px 1px 10px #dddddd !important',
        marginBottom: '40px',
    },
    listRoot: {
        '& li': {
            ['@media (max-width:600px)']: {
                paddingLeft: '0',
                paddingRight: '0',
            },
        },
    },
});

export default useStyles;
